
import { Options, Vue } from "vue-class-component";
import { useStore }     from "vuex";
import { key }          from "@/store";

import { library }         from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faStar }          from "@fortawesome/free-solid-svg-icons";

library.add( faStar );

@Options( {
  components : { FontAwesomeIcon }
} )
export default class Avis extends Vue
{
  store      = useStore( key );
  gm         = this.store.state.gm;
  avis_shown = 4;
}
